<template>
  <div>
    <b-form @submit="onSubmitFormSearch">
      <b-form-row>

        <b-form-group class="col-sm-12 col-md-5" label="Numero de vuelo*">
          <b-form-input
            :state="formValidate.flightNumber"
            v-model="formJSON.flightNumber"
            v-on:keyup="validateForm()"
            placeholder="DL0001"
          ></b-form-input>
        </b-form-group>

        <b-form-group class="col-sm-12 col-md-5" label="Fecha*">
          <b-form-datepicker
            :state="formValidate.flightDate"
            v-model="formJSON.flightDate"
            @input="validateForm()"
            placeholder="Fecha de vuelo"
          ></b-form-datepicker>
        </b-form-group>

        <div
          class="col-sm-12 col-md-2 d-flex flex-row align-items-end"
          label="Fecha*"
        >
          <b-button
            type="submit"
            variant="primary"
            class="w-100 u:h-fit-content u:mb-2"
            >Buscar</b-button
          >
        </div>
      </b-form-row>
    </b-form>

    <b-overlay
      id="overlay-background"
      :show="showLoadingSearch"
      variant="dark"
      opacity="0.61"
      :blur="'2px'"
      rounded="sm"
    />

    <div v-if="arrayFlight.length > 0">
      <b-card border-variant="dark" class="p-0">
        <b-row
          v-for="(itemFlight, index) in arrayFlight"
          :key="index"
          class="mb-1"
        >
			<!-- datos del vuelo general -->
          <b-col class="col-12" v-if="index == 0">
            <b-container>
              <b-row align="center">
                <b-col class="6">
                  <h5 class="m-0 text-primary">{{ itemFlight.airline }}</h5>
                  <h6 class="m-0 text-muted u:text-size-2">Aereolina</h6>
                </b-col>
                <b-col class="6">
                  <h5 class="m-0 text-primary">{{ itemFlight.number }}</h5>
                  <h6 class="m-0 text-muted u:text-size-2">Numero de vuelo</h6>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
			<!-- datos de salida -->
          <b-col class="col-6">
            <div class="d-flex flex-row">
              <div class="u:w-2 bg-warning"></div>
              <b-container>
                <b-row>
                  <b-col>
                    <h6><md-icon icon="flight_takeoff" /> Salida</h6>
                    <b-row class="justify-content-end">
                      <b-col class="col-11 u:text-size-2">
                        <div>
                          {{ itemFlight.departure.airportIata }}
                        </div>
                        <div>
                          Partiendo de:
                          <strong>{{
                            itemFlight.departure.airportName
                          }}</strong>
                        </div>
                        <div>
                          <strong>Codigo de ciudad: </strong
                          >{{ itemFlight.departure.countryCode }}
                        </div>
                        <div>
                          {{ formatDate(itemFlight.departure.scheduledTime)
                          }}<br />
                          <strong>{{
                            formateTime(itemFlight.departure.scheduledTime)
                          }}</strong
                          ><span :class="[itemFlight.departure.delay=='A tiempo'?'text-primary':'text-danger']">
                            ({{
                              itemFlight.departure.delay == "A tiempo"
                                ? "A tiempo"
                                : "Atrasado " + itemFlight.departure.delay
                            }})</span
                          >
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
			<!-- datos de llegada -->
          <b-col class="col-6">
            <div class="d-flex flex-row">
              <b-container>
                <b-row>
                  <b-col>
                    <h6><md-icon icon="flight_land" /> Llegada</h6>
                    <b-row class="justify-content-end">
                      <b-col class="col-11 u:text-size-2">
                        <div>
                          {{ itemFlight.arrival.airportIata }}
                        </div>
                        <div>
                          Arribando a:
                          <strong>{{ itemFlight.arrival.airportName }}</strong>
                        </div>
                        <div>
                          <strong>Codigo de ciudad: </strong
                          >{{ itemFlight.arrival.countryCode }}
                        </div>
                        <div>
                          <div>
                            {{ formatDate(itemFlight.arrival.scheduledTime)
                            }}<br />
                            <strong>{{
                              formateTime(itemFlight.arrival.scheduledTime)
                            }}</strong
                            ><span :class="[itemFlight.arrival.delay=='A tiempo'?'text-primary':'text-danger']">
                              ({{
                                itemFlight.arrival.delay == "A tiempo"
                                  ? "A tiempo"
                                  : "Atrasado " + itemFlight.arrival.delay
                              }})</span
                            >
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
              <div class="u:w-2 bg-success"></div>
            </div>
          </b-col>
			<!-- barra que se dibuja como separador de items -->
          <b-col class="col-12" v-if="index != arrayFlight.length - 1">
            <hr />
          </b-col>
			<b-col class="col-12 text-right" v-if="getCachedValue(itemFlight)">
				<small class="mr-2 text-muted">Cached</small>
			</b-col>
        </b-row>
      </b-card>
    </div>

    <b-card border-variant="dark" v-else>
      <b-card-text>
        <b-container>
          <b-row align="center">
            <b-col class="12">
              <h4 class="mb-0 text-primary">Sin detalles de vuelo</h4>
              <h6 class="text-muted">
                No se encontraron registros del número de vuelo y fecha
              </h6>
            </b-col>
          </b-row>
        </b-container>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
// import Multiselect from "vue-multiselect";
import api from "@/api.js";
import moment from "moment";
export default {
  // components: { Multiselect },
  data() {
    return {
      arrayFlight: [],
      itemFlight: {},
      showLoadingSearch: false,
      formJSON: {
        flightNumber: "",
        flightDate: "",
      },
      formValidate: {
        flightNumber: false,
        flightDate: false,
      },
    };
  },
  mounted() {
    var date = moment("2014-02-27").format("LLLL");
    console.log(date);
  },
  methods: {
    formatDate(item) {
      //obtenemos el dia
      let dia = moment(item).format("dddd");
      //capitalizamos la primera letra a mayusculas
      dia = dia.charAt(0).toUpperCase() + dia.slice(1);
      return dia + "," + moment(item).format("YY-MM-DD");
    },
    formateTime(item) {
      return moment(item).format("HH:mm:ss");
    },
    // nameWithLang({id, name}){
    // 	return `${id} — [${name}]`
    // },
    toggleSelectedAereopuerto(item) {
      console.log(item);
    },
    toggleSelectedFecha() {},
    validateForm() {
      //validamos el campo #numero de vuelo
      if (this.formJSON.flightNumber.length <= 0) {
        this.formValidate.flightNumber = false;
        return;
      }
      this.formValidate.flightNumber = true;
      //validamos el campo #fecha de vuelo
      if (this.formJSON.flightDate.length <= 0) {
        this.formValidate.flightDate = false;
        return;
      }
      this.formValidate.flightDate = true;
      return true;
    },
    onSubmitFormSearch(event) {
      event.preventDefault();
      //verificamos si el formulario se lleno correctamente
      if (!this.validateForm()) {
        this.$root.showAlert("Formulario incompletdo", { variant: "danger" });
        return;
      }
      this.showLoadingSearch = true;
      //realizamos la peticion al endpoint
      api(this)
        .get(
          "/flights/scheduled?flightNumber=" +
            this.formJSON.flightNumber +
            "&flightDate=" +
            this.formJSON.flightDate
        )
        .then((res) => {
          console.log(res.data);
          //recuperamos los detalles del vuelo
          if (res.data.length > 0) {
            this.arrayFlight = res.data;
          } else {
            this.arrayFlight = [];
          }
          console.log(this.arrayFlight);
        })
        .catch(this.$root.handleRequestError)
        .finally(() => {
          this.showLoadingSearch = false;
        });
    },
	getCachedValue(item){
		return item.fromCache??false
	}
  },
};
</script>

<style scoped>
.u\:w-2 {
  width: 0.5rem;
}
.u\:w-fit-content {
  width: fit-content;
}
.u\:h-fit-content {
  height: fit-content;
}
.u\:mb-2 {
  margin-bottom: 0.3rem;
}

/* tamanio fuebnte:::::::::::::::::::::::::::::::::: */
.u\:text-size-1 {
  font-size: 0.55rem;
}
.u\:text-size-2 {
  font-size: 0.75rem;
}
.u\:text-size-3 {
  font-size: 0.97rem;
}
.u\:text-size-4 {
  font-size: 1.22rem;
}
.u\:text-size-5 {
  font-size: 1.467rem;
}
.u\:text-size-6 {
  font-size: 1.71rem;
}
.u\:text-size-7 {
  font-size: 2.2rem;
}
.u\:text-size-8 {
  font-size: 3.54rem;
}
.u\:text-size-9 {
  font-size: 4.15rem;
}
.u\:text-size-10 {
  font-size: 6.11rem;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
